<div class="asset-grid">
  <!-- Search and View Controls -->
  <div class="asset-grid--controls">
    <div class="asset-grid--search-wrapper">
      <div class="asset-grid--search">
        <input
          type="text"
          class="asset-grid--search-input"
          [placeholder]="searchPlaceholder"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange()"
        />
        <img src="/filters/search-normal.svg" alt="Search" class="asset-grid--search-icon" />
      </div>
      
      <!-- Mobile: Filter, Bookmarks, and Like Buttons Group -->
      <div class="asset-grid--mobile-actions">
        <!-- Mobile Filter Button -->
        <button 
          *ngIf="showMobileFilterButton"
          class="asset-grid--mobile-filter-btn"
          (click)="onMobileFilterClick()"
          aria-label="Open filters">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        
        <!-- Bookmarks Toggle Button (Mobile) -->
        <button 
          *ngIf="showBookmarkLikeButtons"
          class="asset-grid--bookmarks-toggle asset-grid--mobile-action-btn asset-grid--has-lock-overlay"
          [class.active]="isLoggedIn && bookmarksActive"
          [class.locked]="!isLoggedIn"
          (click)="toggleBookmarks()"
          type="button"
          [attr.aria-pressed]="isLoggedIn && bookmarksActive"
          [attr.aria-disabled]="!isLoggedIn"
        >
          <svg class="asset-grid--bookmarks-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" 
                  [attr.fill]="(isLoggedIn && bookmarksActive) ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
          </svg>
          <span *ngIf="!isLoggedIn" class="asset-grid--lock-overlay">
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
        </button>
        
        <!-- Like Toggle Button (Mobile) -->
        <button 
          *ngIf="showBookmarkLikeButtons"
          class="asset-grid--like-toggle asset-grid--mobile-action-btn asset-grid--has-lock-overlay"
          [class.active]="isLoggedIn && likeActive"
          [class.locked]="!isLoggedIn"
          (click)="toggleLike()"
          type="button"
          [attr.aria-pressed]="isLoggedIn && likeActive"
          [attr.aria-disabled]="!isLoggedIn"
        >
          <svg class="asset-grid--like-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" 
                  [attr.fill]="(isLoggedIn && likeActive) ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
          </svg>
          <span *ngIf="!isLoggedIn" class="asset-grid--lock-overlay">
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
        </button>
        <!-- Sort Dropdown (Mobile) – same design as desktop -->
        <div class="asset-grid--sort asset-grid--custom-dropdown" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="asset-grid--dropdown-trigger asset-grid--dropdown-trigger-mobile"
            [class.open]="sortDropdownOpen"
            (click)="toggleSortDropdown($event)"
          >
            <span>Sort: <span class="asset-grid--sort-value">{{ getSelectedSortLabel() }}</span></span>
            <span class="asset-grid--sort-icon" [class.open]="sortDropdownOpen">⇅</span>
          </button>
          <div class="asset-grid--dropdown-panel" *ngIf="sortDropdownOpen">
            <div
              *ngFor="let opt of displaySortOptions"
              class="asset-grid--dropdown-option"
              [class.selected]="sortOption === opt.value"
              (click)="selectSortOption(opt.value, $event)"
            >
              <div class="checkbox-checkmark-custom" [class.checked]="sortOption === opt.value"></div>
              <span>{{ opt.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Desktop: Bookmarks and Like Buttons Container -->
    <div class="asset-grid--action-buttons">
      <!-- Bookmarks Toggle Button -->
      <button 
        *ngIf="showBookmarkLikeButtons"
        class="asset-grid--bookmarks-toggle asset-grid--has-lock-overlay"
        [class.active]="isLoggedIn && bookmarksActive"
        [class.locked]="!isLoggedIn"
        (click)="toggleBookmarks()"
        type="button"
        [attr.aria-pressed]="isLoggedIn && bookmarksActive"
        [attr.aria-disabled]="!isLoggedIn"
      >
        <svg class="asset-grid--bookmarks-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" 
                [attr.fill]="(isLoggedIn && bookmarksActive) ? '#059669' : 'none'" 
                stroke="#059669" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
        </svg>
        <span *ngIf="!isLoggedIn" class="asset-grid--lock-overlay">
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span>Bookmarks</span>
      </button>
      
      <!-- Like Toggle Button -->
      <button 
        *ngIf="showBookmarkLikeButtons"
        class="asset-grid--like-toggle asset-grid--has-lock-overlay"
        [class.active]="isLoggedIn && likeActive"
        [class.locked]="!isLoggedIn"
        (click)="toggleLike()"
        type="button"
        [attr.aria-pressed]="isLoggedIn && likeActive"
        [attr.aria-disabled]="!isLoggedIn"
      >
        <svg class="asset-grid--like-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" 
                [attr.fill]="(isLoggedIn && likeActive) ? '#059669' : 'none'" 
                stroke="#059669" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
        </svg>
        <span *ngIf="!isLoggedIn" class="asset-grid--lock-overlay">
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span>Like</span>
      </button>

      <!-- Sort Dropdown -->
      <div class="asset-grid--sort asset-grid--custom-dropdown" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="asset-grid--dropdown-trigger"
          [class.open]="sortDropdownOpen"
          (click)="toggleSortDropdown($event)"
        >
          <span>Sort: <span class="asset-grid--sort-value">{{ getSelectedSortLabel() }}</span></span>
          <span class="asset-grid--sort-icon" [class.open]="sortDropdownOpen">⇅</span>
        </button>
        <div class="asset-grid--dropdown-panel" *ngIf="sortDropdownOpen">
          <div
            *ngFor="let opt of displaySortOptions"
            class="asset-grid--dropdown-option"
            [class.selected]="sortOption === opt.value"
            (click)="selectSortOption(opt.value, $event)"
          >
            <div class="checkbox-checkmark-custom" [class.checked]="sortOption === opt.value"></div>
            <span>{{ opt.label }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="asset-grid--controls-right">
      <!-- Items per page selector (Showing dropdown) -->
      <div class="asset-grid--items-per-page asset-grid--custom-dropdown" (click)="$event.stopPropagation()">
        <div class="asset-grid--dropdown-trigger-wrapper">
          <button
            type="button"
            class="asset-grid--dropdown-trigger asset-grid--dropdown-trigger-show"
            [class.open]="showDropdownOpen"
            (click)="toggleShowDropdown($event)"
          >
            <span>Showing: <span class="asset-grid--sort-value">{{ getSelectedShowLabel() }}</span></span>
          </button>
          <div class="asset-grid--dropdown-panel asset-grid--dropdown-panel-right" *ngIf="showDropdownOpen">
          <div
            *ngFor="let option of itemsPerPageOptions"
            class="asset-grid--dropdown-option"
            [class.selected]="itemsPerPage === option"
            (click)="selectShowOption(option, $event)"
          >
            <div class="checkbox-checkmark-custom" [class.checked]="itemsPerPage === option"></div>
            <span><span class="asset-grid--show-option-value">{{ option }}</span> <span class="asset-grid--show-option-suffix">results/page</span></span>
          </div>
        </div>
        </div>
      </div>

      <div class="asset-grid--view-toggle">
      <button
        class="asset-grid--view-btn"
        [class.active]="viewMode === 'grid'"
        (click)="onViewModeChange('grid')"
        aria-label="Grid view"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
          <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
          <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
          <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span class="asset-grid--view-label">Grid</span>
      </button>
      <button
        class="asset-grid--view-btn"
        [class.active]="viewMode === 'list'"
        (click)="onViewModeChange('list')"
        aria-label="List view"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="asset-grid--view-label">List</span>
      </button>
      <button
        class="asset-grid--view-btn"
        [class.active]="viewMode === 'table'"
        (click)="onViewModeChange('table')"
        aria-label="Table view"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M3 3H21V21H3V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 9H21M9 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="asset-grid--view-label">Table</span>
      </button>
    </div>
    </div>
  </div>

  <!-- Empty State Message -->
  <div class="asset-grid--empty-state" *ngIf="filteredAssets.length === 0">
    <p class="asset-grid--empty-message">{{ getEmptyStateMessage() }}</p>
  </div>

  <!-- Asset Cards (Grid/List View) -->
  <div class="asset-grid--container" 
       [class.list-view]="viewMode === 'list'"
       *ngIf="viewMode !== 'table' && filteredAssets.length > 0">
    <!-- Model Cards -->
    <ng-container *ngIf="assetType === 'model'">
      <app-model-card
        *ngFor="let asset of filteredAssets"
        [card]="$any(asset)"
        [showShortDescription]="viewMode === 'list'"
        [isBookmarked]="isAssetBookmarked(asset.id)"
        [isLiked]="isAssetLiked(asset.id)"
        [isLoggedIn]="isLoggedIn"
        (bookmarkChanged)="onBookmarkChanged(asset.id, $event)"
        (likeChanged)="onLikeChanged(asset.id, $event)"
        class="asset-grid--item"
      ></app-model-card>
    </ng-container>
    <!-- Usecase Cards -->
    <ng-container *ngIf="assetType === 'usecase'">
      <app-usecase-card
        *ngFor="let asset of filteredAssets"
        [card]="$any(asset)"
        [showShortDescription]="viewMode === 'list'"
        [isBookmarked]="isAssetBookmarked(asset.id)"
        [isLiked]="isAssetLiked(asset.id)"
        [isLoggedIn]="isLoggedIn"
        (bookmarkChanged)="onBookmarkChanged(asset.id, $event)"
        (likeChanged)="onLikeChanged(asset.id, $event)"
        class="asset-grid--item"
      ></app-usecase-card>
    </ng-container>
    <!-- Feature Cards (for datasets only) -->
    <ng-container *ngIf="assetType === 'dataset'">
      <app-feature-card
        *ngFor="let asset of filteredAssets"
        [card]="$any(asset)"
        [showShortDescription]="viewMode === 'list'"
        [showOrganizationBelowTitle]="bookmarksActive"
        [isBookmarked]="isAssetBookmarked(asset.id)"
        [isLiked]="isAssetLiked(asset.id)"
        [isLoggedIn]="isLoggedIn"
        (bookmarkChanged)="onBookmarkChanged(asset.id, $event)"
        (likeChanged)="onLikeChanged(asset.id, $event)"
        class="asset-grid--item"
      ></app-feature-card>
    </ng-container>
  </div>

  <!-- Table View - Custom Implementation without PrimeNG expansion -->
  <div class="asset-grid--table-wrapper" *ngIf="viewMode === 'table' && filteredAssets.length > 0">
    <div class="asset-grid--table-container">
      <!-- Decorative Leaf Images -->
      <div class="asset-grid--table-leaf asset-grid--table-leaf-left">
        <img src="/leaf/Group 6.svg" alt="Decorative leaf" class="leaf-image leaf-image-1" />
        <img src="/leaf/Group 8.svg" alt="Decorative leaf" class="leaf-image leaf-image-2" />
      </div>
      <div class="asset-grid--table-leaf asset-grid--table-leaf-right">
        <img src="/leaf/Group 9.svg" alt="Decorative leaf" class="leaf-image leaf-image-3" />
        <img src="/leaf/Group 11.svg" alt="Decorative leaf" class="leaf-image leaf-image-4" />
      </div>
      
      <table class="asset-grid--custom-table">
      <thead>
        <tr>
          <th style="width: 3rem" *ngIf="assetType !== 'usecase'"></th>
          <th>TITLE</th>
          <th *ngIf="assetType === 'dataset'">PROVIDER</th>
          <th *ngIf="assetType === 'model'">INDUSTRY</th>
          <th *ngIf="assetType === 'usecase'">DESCRIPTION</th>
          <th *ngIf="assetType !== 'usecase'">STATUS</th>
          <th>ACTION</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let asset of filteredAssets">
          <!-- Main Row -->
          <tr class="main-row" [attr.data-asset-id]="asset.id">
            <td style="width: 3rem; padding: var(--spacing-md);" *ngIf="assetType !== 'usecase'">
              <button
                type="button"
                class="asset-grid--row-toggle"
                [class.expanded]="expandedRowKeys[asset.id]"
                (click)="toggleExpansion(asset.id)"
                [attr.aria-expanded]="expandedRowKeys[asset.id]"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </td>
            <td>
              <div class="asset-grid--table-title">{{ asset.title }}</div>
            </td>
            <td *ngIf="assetType === 'dataset'">
              {{ $any(asset).organization }}
            </td>
            <td *ngIf="assetType === 'model'">
              {{ $any(asset).industry }}
            </td>
            <td *ngIf="assetType === 'usecase'">
              <div class="asset-grid--table-description">{{ $any(asset).organization || $any(asset).description }}</div>
            </td>
            <td *ngIf="assetType !== 'usecase'">
              <div class="asset-grid--table-badge" 
                   *ngIf="asset.badge" 
                   [ngClass]="'asset-grid--table-badge-' + (asset.badgeColor || 'public')">
                <!-- Globe Icon for Public and Restricted -->
                <svg *ngIf="isPublicBadge(asset.badgeColor) || isRestrictedBadge(asset.badgeColor)" 
                     class="asset-grid--table-badge-icon" 
                     width="14" 
                     height="14" 
                     viewBox="0 0 24 24" 
                     fill="none" 
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 2v20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="12" r="2" fill="currentColor"/>
                </svg>
                <span>{{ asset.badge }}</span>
              </div>
            </td>
            <td>
              <button class="asset-grid--table-action" aria-label="View details" (click)="onActionClick(asset)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </td>
          </tr>
          
          <!-- Expansion Row (not for usecases) -->
          <tr class="expansion-row" *ngIf="assetType !== 'usecase' && expandedRowKeys[asset.id]" [@expandCollapse]>
            <td colspan="5" class="expansion-cell">
              <div class="asset-grid--row-expansion">
                <!-- Left Column: Tags and Metadata stacked -->
                <div class="asset-grid--expansion-left">
                  <div class="asset-grid--expansion-section">
                    <h4 class="asset-grid--expansion-title">Tags</h4>
                    <div class="asset-grid--table-tags">
                      <span class="asset-grid--table-tag" *ngFor="let tag of $any(asset).apiTags || asset.tags">{{ getDisplayTag(tag) }}</span>
                      <span *ngIf="(!$any(asset).apiTags || $any(asset).apiTags.length === 0) && (!asset.tags || asset.tags.length === 0)" class="asset-grid--no-data">No tags available</span>
                    </div>
                  </div>
                  <div class="asset-grid--expansion-section">
                    <h4 class="asset-grid--expansion-title" *ngIf="assetType !== 'model'">Metadata</h4>
                    <h4 class="asset-grid--expansion-title" *ngIf="assetType === 'model'">Model Type</h4>
                    <div class="asset-grid--table-metadata">
                      <!-- For models: show model type and language -->
                      <ng-container *ngIf="assetType === 'model'">
                        <span *ngIf="$any(asset).modelType" class="asset-grid--table-meta-item">{{ $any(asset).modelType }}</span>
                        <span *ngIf="$any(asset).language" class="asset-grid--table-meta-item">{{ $any(asset).language }}</span>
                        <span *ngIf="!$any(asset).modelType && !$any(asset).language" class="asset-grid--no-data">No model type information available</span>
                      </ng-container>
                      <!-- For datasets and usecases: show original metadata -->
                      <ng-container *ngIf="assetType !== 'model'">
                        <span *ngFor="let tag of asset.tags" class="asset-grid--table-meta-item">{{ tag }}</span>
                        <span *ngIf="$any(asset).percentage" class="asset-grid--table-meta-item">
                          <img src="/shield-check.svg" alt="Shield" class="asset-grid--table-meta-icon" />
                          {{ $any(asset).percentage }}%
                        </span>
                        <span *ngIf="!asset.tags?.length && !$any(asset).percentage" class="asset-grid--no-data">No metadata available</span>
                      </ng-container>
                    </div>
                  </div>
                </div>
                
                <!-- Right Column: Additional Information -->
                <div class="asset-grid--expansion-right">
                  <div class="asset-grid--expansion-section">
                    <h4 class="asset-grid--expansion-title">Additional Information</h4>
                    <div class="asset-grid--dummy-content">
                      <p><strong>Description:</strong> This is a sample dataset containing agricultural information for Maharashtra state.</p>
                      <p><strong>Last Updated:</strong> {{ $any(asset).date || 'N/A' }}</p>
                      <p *ngIf="assetType === 'dataset'"><strong>Data Quality:</strong> {{ $any(asset).percentage || 'N/A' }}%</p>
                      <p *ngIf="assetType === 'dataset'"><strong>Format:</strong> {{ $any(asset).fileType || 'CSV' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination -->
  <div class="asset-grid--pagination" *ngIf="getEffectiveTotalPages() > 1">
    <!-- First Page Button -->
    <button
      class="asset-grid--pagination-btn"
      [disabled]="currentPage === 1"
      (click)="onPageChange(1)"
      aria-label="First page"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M11 18L5 12L11 6M18 18L12 12L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Previous Page Button -->
    <button
      class="asset-grid--pagination-btn"
      [disabled]="currentPage === 1"
      (click)="onPageChange(currentPage - 1)"
      aria-label="Previous page"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <div class="asset-grid--pagination-numbers">
      <button
        *ngFor="let page of getPageNumbers()"
        class="asset-grid--pagination-number"
        [class.active]="page === currentPage"
        (click)="onPageChange(page)"
      >
        {{ page }}
      </button>
    </div>

    <!-- Next Page Button -->
    <button
      class="asset-grid--pagination-btn"
      [disabled]="currentPage === getEffectiveTotalPages()"
      (click)="onPageChange(currentPage + 1)"
      aria-label="Next page"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Last Page Button -->
    <button
      class="asset-grid--pagination-btn"
      [disabled]="currentPage === getEffectiveTotalPages()"
      (click)="onPageChange(getEffectiveTotalPages())"
      aria-label="Last page"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M13 18L19 12L13 6M6 18L12 12L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>

